import { CreateByTypeStrategy, ModelFactory } from '../../'
import { QuestionContextTypeService } from '../../../services'
import { QuestionContext } from '../../../models'
import { Observable } from 'rxjs/Observable'

const TYPE_KEY = 'questionContextType'

export class QuestionContextCreateByTypeStrategy extends CreateByTypeStrategy {

  public constructor(
    _questionContextTypeService: QuestionContextTypeService,
    _modelFactory: ModelFactory
  ) {
    super(_questionContextTypeService, _modelFactory, QuestionContext.name, TYPE_KEY)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/factories/strategies/question-context-create-by-type/question-context-create-by-type.strategy.ts